import { debounce, isNil } from "lodash-es";
import { useCallback, useEffect } from "react";

/** Runs provided callback once on mount. */
export const useRunOnceOnMount = (callback: () => void, options?: { delayMs?: number }): void => {
  const _callback = useCallback(
    // eslint-disable-next-line react-hooks/use-memo
    debounce(
      () => {
        if (!isNil(options?.delayMs) && options!.delayMs! > 0) {
          setTimeout(callback, options?.delayMs);
        } else {
          callback();
        }
      },
      5000,
      { leading: true, trailing: false },
    ),
    [callback, options],
  );

  useEffect(() => {
    _callback();
  }, []);
};
